import { render, staticRenderFns } from "./form-item-wrapper.vue?vue&type=template&id=e1cf9888&scoped=true&"
import script from "./form-item-wrapper.vue?vue&type=script&lang=js&"
export * from "./form-item-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./form-item-wrapper.vue?vue&type=style&index=0&id=e1cf9888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cf9888",
  null
  
)

export default component.exports